import * as React from 'react'
import {RouteComponentProps} from 'react-router'
import Card from 'study_coordinator/components/Card'
import {createConnectedSubjectForm} from 'study_coordinator/components/subjects'

const SubjectForm = createConnectedSubjectForm({formName: 'SubjectCreatePage SubjectForm'})

interface IStateProps {
}
interface IOwnProps extends RouteComponentProps<void> {}

interface IProps extends IStateProps, IOwnProps {}

class SubjectCreatePage extends React.PureComponent<IProps, {}> {
  public render() {
    return (
      <div>
        <Card>
          <SubjectForm />
        </Card>
      </div>
    )
  }
}

export default SubjectCreatePage



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_coordinator/src/pages/SubjectCreatePage.tsx